import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import addressNickname from '../../defaultFieldDefinitions/AddressNickname';
import defaultDeliveryAddress from '../../defaultFieldDefinitions/DefaultDeliveryAddressTickBox';
import defaultBillingAddress from '../../defaultFieldDefinitions/DefaultBillingAddressTickBox';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import ukPostcode from '../../validationByCountry/UK/uk-postcode';

const formatUkPostcode = (value) => {
  if (!value) {
    return value;
  }
  const parts = value.toUpperCase().match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})/);
  if (parts) {
    parts.shift();
    return parts.join(' ');
  }
  return value.toUpperCase();
};

const FieldDefinitionGBWithPostCodeAnywhere = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    element: 'PostcodeAnywhere',
    required: true,
    transform: formatUkPostcode,
    validate: [required.postCode, max.lengthPostCode(10), ukPostcode],
    fields: [
      companyName,
      nameNumber,
      streetName,
      addressLine2,
      townCity,
      {
        name: 'county',
        label: 'checkout.address.field.label.county.text',
        maxLength: 35,
        validate: max.lengthAddress(35),
      },
    ],
  },
];

const FieldDefinitionGBDefault = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    transform: formatUkPostcode,
    validate: [required.postCode, max.lengthPostCode(10), ukPostcode],
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  townCity,
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    maxLength: 35,
    validate: max.lengthAddress(35),
  },
];

const {clientExperiments} = window.start.siteDataV2;

const shouldHidePCA = (window.start.settings.postcode_anywhere_disabled
  || clientExperiments?.loqate_us_wave_01 === 'v1|enable_loqate'
  || clientExperiments?.loqate_de_wave_01 === 'v1|enable_loqate')
  || window.start.settings.address_lookup_countries?.includes('GB');

let FieldDefinitionGB = shouldHidePCA ? FieldDefinitionGBDefault : FieldDefinitionGBWithPostCodeAnywhere;

const addressNicknameEnabled = window.start.settings.address_nickname_enabled;

FieldDefinitionGB = addressNicknameEnabled ? [...FieldDefinitionGB, addressNickname] : FieldDefinitionGB;

const defaultDeliveryTickboxEnabled = window.start.settings.default_delivery_address_tickbox_enabled;
const defaultBillingTickboxEnabled = window.start.settings.default_billing_address_tickbox_enabled;

FieldDefinitionGB = (defaultDeliveryTickboxEnabled && window.start.addresses?.addresses.length >= 2)
  ? [...FieldDefinitionGB, defaultDeliveryAddress] : FieldDefinitionGB;
FieldDefinitionGB = (defaultBillingTickboxEnabled && window.start.addresses?.addresses.length >= 2)
  ? [...FieldDefinitionGB, defaultBillingAddress] : FieldDefinitionGB;

const exportFieldDefinitionGB = FieldDefinitionGB;
export default exportFieldDefinitionGB;
